import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DIMENSIONS } from 'services/layoutManager';
import BloxPage from 'sub_components/Layout/BloxPage';
import ComponentWrapper from 'sub_components/Layout/ComponentWrapper';
import { RESOLUTIONS } from 'services/config';
import { Forecast } from 'styled_components/Colo/Forecast';
import { updateModule, updatePage, addPageToBreadCrumbs } from 'actions/siteTracking';
import { updatePermissions } from 'actions/permissions';
import { MENU as COLO_MENU } from 'utils/ColoConstants';
import { SITE_PAGES, SITE_MODULES } from 'utils/CommonConstants';
import { Utils } from 'services/utils';
import { Permissions } from 'services/permissions';

const LAYOUT_CONFIG = {
	[RESOLUTIONS.LOW]: {
		topLeft: { x: 1, y: 2, dim: DIMENSIONS.FOUR_BY_FOUR },
		component1: { x: 5, y: 2, dim: DIMENSIONS.FOUR_BY_FOUR },
	},
	[RESOLUTIONS.MED]: {
		topLeft: { x: 1, y: 0, dim: DIMENSIONS.EIGHT_BY_TEN },
		component1: { x: 5, y: 2, dim: DIMENSIONS.FOUR_BY_FOUR },
	},
	[RESOLUTIONS.HIGH]: {
		topLeft: { x: 1, y: 3, dim: DIMENSIONS.EIGHT_BY_TEN },
		component1: { x: 5, y: 2, dim: DIMENSIONS.FOUR_BY_FOUR },
	},
};

class EnvironmentPage extends Component {
	constructor() {
		super();
		this.state = {
			showTitleTicketCount: true,
			pages: null,
		};
	}
	componentDidMount() {
		const { updateModule, updatePage, addPageToBreadCrumbs, site, permissions } = this.props;
		updatePage(SITE_PAGES.COLO[COLO_MENU.BADGE]);
		addPageToBreadCrumbs(SITE_PAGES.COLO[COLO_MENU.BADGE], SITE_MODULES.COLO);
		if (site?.module !== 'COLO' || !permissions?.permissions) {
			this.getModulePages();
		}
		updateModule(SITE_MODULES.COLO);
		this.getModulePages();
	}
	componentWillUnmount() {
		Utils.removeHorizontalBar();
	}
	getModulePages = async () => {
		const {
			updatePermissions,
			auth_status: {
				user: { id: userId },
			},
			company_info: {
				customer: { id: orgId },
			},
		} = this.props;
		const response = await Permissions.getModulePermissions(5, userId, orgId);

		if (response && !response.data.error) {
			updatePermissions(response.data.pages);
		}
	};
	showTitleTicketCount = show => {
		const { showTitleTicketCount } = this.state;

		if (showTitleTicketCount !== show) {
			this.setState({ showTitleTicketCount: show });
		}
	};
	goToTicketHistory = (status, type) => {
		const { navigate } = this.props;
		navigate('/portal/support/ticket_history', { state: { status, type } });
	};

	render() {
		const { breakpoint, location, site } = this.props;
		const { pages } = this.state;
		console.log(pages);
		// const ViewTicketStatus = Permissions.checkComponentAccess(
		// 	pages,
		// 	'Storage Overview',
		// 	'view-ticket-status',
		// );

		return (
			<BloxPage
				name='sample-content-grid storage'
				layout={LAYOUT_CONFIG[breakpoint]}
				breakpoint={breakpoint}
				location={location}
			>
				<div key={`topLeft`} className='topLeft'>
					{/* {ViewTicketStatus && ( */}
					<ComponentWrapper site={site} breakpoint={breakpoint} hideTitle hideBorder>
						<Forecast datacenter='BHM' />
					</ComponentWrapper>
					{/* )} */}
				</div>
				<div key={`component1`} className='component1'>
					{/* {ViewTicketStatus && ( */}
					<ComponentWrapper site={site} breakpoint={breakpoint} hideTitle hideBorder>
						Weather Alerts
					</ComponentWrapper>
					{/* )} */}
				</div>
			</BloxPage>
		);
	}
}
function mapStateToProps(state) {
	return {
		site: state.site_tracking,
		permissions: state.permissions,
		auth_status: state.auth_status,
		company_info: state.company_info,
	};
}

export default connect(mapStateToProps, {
	updateModule,
	updatePage,
	addPageToBreadCrumbs,
	updatePermissions,
})(EnvironmentPage);
